import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PostForm from './PostForm';
import HideOnScroll from './HideOnScroll';
import { getCircularAvatar } from '../utils/cloudinaryTransform';
import { SvgIcon } from '@material-ui/core';
import { DialogTitle, DialogContent } from './CustomDialogTitle';

import {
  Dialog,
  Button,
  Fab,
  IconButton,
  Paper,
  Avatar,
  useMediaQuery,
  MenuItem,
  ListItemIcon,
} from '@material-ui/core';
import { useDialogStyles } from '../styles/muiStyles';
import { useTheme } from '@material-ui/core/styles';

import { ReactComponent as AddImage } from '../svg/addImage.svg';
import PostAddIcon from '@material-ui/icons/PostAdd';

import { ReactComponent as LinkIcon } from '../svg/linkIcon.svg';

// import LinkIcon from '@material-ui/icons/Link';
import EditIcon from '@material-ui/icons/Edit';

const AddPostModal = ({
  actionType,
  handleMenuClose,
  postToEditType,
  postToEditTitle,
  postToEditSub,
  postToEditId,
  textSubmission,
  linkSubmission,
  fromSubreddit,
}) => {
  const [open, setOpen] = useState(false);
  const [postType, setPostType] = useState('Text');
  const user = useSelector((state) => state.user);

  const classes = useDialogStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleTextPost = () => {
    setPostType('Text');
    handleClickOpen();
  };

  const handleImagePost = () => {
    setPostType('Image');
    handleClickOpen();
  };

  const handleLinkPost = () => {
    setPostType('Link');
    handleClickOpen();
  };

  const handleMenuClick = () => {
    handleClickOpen();
    handleMenuClose();
  };

  if (!user) {
    return null;
  }

  return (
    <div>
      {actionType === 'edit' ? (
        <MenuItem onClick={handleMenuClick}>
          <ListItemIcon>
            <EditIcon style={{ marginRight: 1 }} />
            Edit Post
          </ListItemIcon>
        </MenuItem>
      ) : isMobile ? (
        <Paper variant="outlined" className={classes.createPostWrapper}>
          {user.avatar && user.avatar.exists ? (
            <Avatar
              alt={user.username}
              src={getCircularAvatar(user.avatar.imageLink)}
            />
          ) : (
            <Avatar className={classes.defaultAvatar}>
              {user.username[0]}
            </Avatar>
          )}
          <Button
            color="primary"
            variant="outlined"
            onClick={handleTextPost}
            fullWidth
            className={classes.createBtn}
            startIcon={<PostAddIcon />}
            size="large"
          >
            Create Post
          </Button>
          <div className={classes.iconGroup}>
            <IconButton onClick={handleImagePost}>
            <SvgIcon  color="primary" fontSize="small">
              <AddImage />
              </SvgIcon>
            </IconButton>
            <IconButton  onClick={handleLinkPost}>
              <SvgIcon  color="primary" fontSize="small">
                <LinkIcon />
              </SvgIcon>
            </IconButton>
          </div>
        </Paper>
      ) : (
        <Paper variant="outlined" className={classes.createPostWrapper}>
          {user.avatar && user.avatar.exists ? (
            <Avatar
              alt={user.username}
              src={getCircularAvatar(user.avatar.imageLink)}
            />
          ) : (
            <Avatar className={classes.defaultAvatar}>
              {user.username[0]}
            </Avatar>
          )}
          <Button
            color="primary"
            variant="outlined"
            onClick={handleTextPost}
            fullWidth
            className={classes.createBtn}
            startIcon={<PostAddIcon />}
            size="large"
          >
            Create Post
          </Button>
          <div className={classes.iconGroup}>
            <IconButton onClick={handleImagePost}>
            <SvgIcon  color="primary" fontSize="small">
              <AddImage />
              </SvgIcon>
            </IconButton>
            <IconButton  onClick={handleLinkPost}>
              <SvgIcon  color="primary" fontSize="small">
                <LinkIcon />
              </SvgIcon>
            </IconButton>
          </div>
        </Paper>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        classes={{ paper: classes.dialogWrapper }}
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle  style={{ textAlign: "center" }} onClose={handleClose}>
          {actionType === 'edit' ? 'Update your post' : 'Add a new post'}
        </DialogTitle>
        <DialogContent>
          <PostForm
            actionType={actionType}
            postType={postType}
            postToEditType={postToEditType}
            postToEditTitle={postToEditTitle}
            postToEditSub={postToEditSub}
            postToEditId={postToEditId}
            textSubmission={textSubmission}
            linkSubmission={linkSubmission}
            fromSubreddit={fromSubreddit}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddPostModal;
